"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = InfoIcon;

var _react = _interopRequireWildcard(require("react"));

var _underscore = require("FileManagerCore/vendor/underscore.custom");

var colors = _interopRequireWildcard(require("HubStyleTokens/colors"));

function InfoIcon(props) {
  var color = props.color,
      className = props.className;
  var path = "path-" + (0, _underscore.uniqueId)();
  var mask = "mask-" + (0, _underscore.uniqueId)();
  return _react.default.createElement("svg", {
    className: className,
    width: "18px",
    height: "18px",
    viewBox: "0 0 18 18",
    xmlns: "http://www.w3.org/2000/svg"
  }, _react.default.createElement("defs", null, _react.default.createElement("path", {
    d: "M647 406C643.130556 406 640 409.129592 640 412.997845 640 416.866099 643.130556 419.995691 647 419.995691 650.869444 419.995691 654 416.866099 654 412.997845 654 409.129592 650.869444 406 647 406L647 406ZM647.894444 408.177107C648.166667 408.177107 648.4 408.2743 648.536111 408.449246 648.672222 408.624192 648.75 408.838015 648.75 409.071277 648.75 409.65443 648.283333 410.218146 647.622222 410.218146L647.602778 410.218146C647.097222 410.218146 646.766667 409.829377 646.766667 409.2851 646.766667 408.799138 647.155556 408.177107 647.894444 408.177107L647.894444 408.177107ZM648.730556 416.010807C647.758333 417.079922 646.552778 417.721391 646.086111 417.721391L646.086111 417.721391C645.930556 417.721391 645.775 417.682514 645.658333 417.546445 645.541667 417.410376 645.483333 417.215991 645.483333 416.943853 645.483333 416.73003 645.522222 416.263507 645.6 415.933053L646.3 412.900653C646.338889 412.725707 646.358333 412.609076 646.358333 412.550761 646.241667 412.589638 645.697222 412.978407 645.444444 413.19223L645.347222 413.269984 645.075 412.531322 645.133333 412.473007C646.125 411.559399 647.311111 410.820738 647.855556 410.820738 648.011111 410.820738 648.147222 410.898492 648.225 411.034561 648.302778 411.17063 648.322222 411.326138 648.322222 411.520523 648.322222 411.734346 648.283333 412.18143 648.225 412.473007L647.447222 415.602599C647.408333 415.758107 647.388889 415.855299 647.388889 415.933053L647.388889 416.010807C647.466667 415.991368 648.011111 415.622038 648.380556 415.291584L648.458333 415.21383 648.75 415.855299 648.788889 415.913614 648.730556 416.010807 648.730556 416.010807Z",
    id: path
  }), _react.default.createElement("mask", {
    id: mask,
    maskContentUnits: "userSpaceOnUse",
    maskUnits: "objectBoundingBox",
    x: "-2",
    y: "-2",
    width: "18",
    height: "17.9956909"
  }, _react.default.createElement("rect", {
    x: "638",
    y: "404",
    width: "18",
    height: "17.9956909",
    fill: "white"
  }), _react.default.createElement("use", {
    xlinkHref: "#" + path,
    fill: "black"
  }))), _react.default.createElement("g", {
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, _react.default.createElement("g", {
    transform: "translate(-638.000000, -404.000000)"
  }, _react.default.createElement("g", null, _react.default.createElement("use", {
    fill: color,
    fillRule: "evenodd",
    xlinkHref: "#" + path
  }), _react.default.createElement("use", {
    stroke: "#FFFFFF",
    mask: "url(#" + mask + ")",
    strokeWidth: "4",
    xlinkHref: "#" + path
  })))));
}

InfoIcon.propTypes = {
  className: _react.PropTypes.string,
  color: _react.PropTypes.string.isRequired
};
InfoIcon.defaultProps = {
  color: colors.OBSIDIAN
};
module.exports = exports.default;